import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";

// Register Chart.js components
Chart.register(...registerables);

function ChartPerform() {
    const chartRef = useRef(null);
    let chartInstance = useRef(null);

    useEffect(() => {
        const ctx = chartRef.current.getContext("2d"); // Corrected "2d"

        // Destroy previous chart instance if it exists
        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        chartInstance.current = new Chart(ctx, {
            type: "bar",
            data: {
                labels: [
                    "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ],
                datasets: [
                    {
                        label: "Marketing",
                        data: [1000, 5000, 400, 800, 750, 690, 700, 550, 890, 900, 940, 870],
                        backgroundColor: "rgba(255, 99, 132, 0.5)",
                        borderColor: "rgb(255, 99, 132)",
                        borderWidth: 1,
                        barThickness: 8,
                        categoryPercentage: 0.9,
                        barPercentage: 0.95
                    },
                    {
                        label: "Branding",
                        data: [9000, 850, 780, 850, 820, 800, 770, 790, 830, 850, 810, 840],
                        backgroundColor: "rgba(255, 159, 64, 0.5)",
                        borderColor: "rgb(255, 159, 64)",
                        borderWidth: 1,
                        barThickness: 8,
                        categoryPercentage: 0.9,
                        barPercentage: 0.95
                    },
                    {
                        label: "Server",
                        data: [600, 650, 700, 680, 720, 950, 6900, 710, 730, 750, 700, 740],
                        backgroundColor: "rgba(255, 205, 86, 0.5)",
                        borderColor: "rgb(255, 205, 86)",
                        borderWidth: 1,
                        barThickness: 8,
                        categoryPercentage: 0.9,
                        barPercentage: 0.95
                    },
                    {
                        label: "Media",
                        data: [850, 880, 820, 900, 870, 850, 860, 880, 8900, 910, 870, 900],
                        backgroundColor: "rgba(75, 192, 192, 0.5)",
                        borderColor: "rgb(75, 192, 192)",
                        borderWidth: 1,
                        barThickness: 8,
                        categoryPercentage: 0.9,
                        barPercentage: 0.95
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    title: {
                        display: true,
                        text: "Top Performing Branch by Category",
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            stepSize: 20   // interval of 20
                        }
                    },
                },
            },
        });

        // Cleanup on unmount
        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <div className="card-body">
            {/* <h5 className="card-title">Top Performing Branch</h5> */}
            <div className="mt-4" style={{ maxHeight: "600px" }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
}

export default ChartPerform;
